import React from 'react'
import classnames from 'classnames'
import styles from './styles.less'

const Badge = ({ severity = 'info', text, size = 'xs' }) => {
  return <p className={classnames(styles.severity, styles[severity.toLowerCase()], styles[size])}>{text || severity.toLowerCase()}</p>
}

export default Badge
